import React from "react";

function place(b) {
    const a = [b.cap, b.comune].filter(Boolean).join(" ");
    const p = b.provincia ? `(${b.provincia})` : "";
    return [a, p].filter(Boolean).join(" ").trim();
}

export default function DocumentHeader({ branding, docTitle, docSubtitle }) {
    if (!branding) return null;

    return (
        <div className="mb-4 rounded-2xl shadow bg-white overflow-hidden">
            <div className="p-4 flex gap-4 items-center">
                <div className="w-16 h-16 shrink-0 rounded-2xl border bg-gray-50 overflow-hidden flex items-center justify-center">
                    {branding.logo_url ? (
                        <img src={branding.logo_url} alt="Logo" className="w-full h-full object-contain" />
                    ) : (
                        <div className="text-xs opacity-60 text-center px-2">LOGO</div>
                    )}
                </div>

                <div className="flex-1">
                    <div className="text-lg font-semibold">{branding.nome}</div>

                    <div className="text-sm opacity-80">
                        {branding.indirizzo ? (
                            <>
                                {branding.indirizzo}
                                {" — "}
                                {place(branding)}
                            </>
                        ) : (
                            place(branding)
                        )}
                    </div>

                    <div className="text-sm opacity-80">
                        {branding.partita_iva && <span>P.IVA: {branding.partita_iva}</span>}
                        {branding.codice_univoco && <span> — Codice Univoco: {branding.codice_univoco}</span>}
                    </div>
                </div>

                <div className="text-right">
                    <div className="text-sm font-semibold">{docTitle}</div>
                    {docSubtitle && <div className="text-xs opacity-70">{docSubtitle}</div>}
                    <div className="text-xs opacity-70">
                        Generato il: {new Date().toLocaleDateString("it-IT")}
                    </div>
                </div>
            </div>
        </div>
    );
}
